module.exports = __webpack_public_path__ + "img/68364f0.jpg";